var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreNavIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6602 10.9395L20.6802 15.1195C19.8402 18.7295 18.1802 20.1895 15.0602 19.8895C14.5602 19.8495 14.0202 19.7595 13.4402 19.6195L11.7602 19.2195C7.59018 18.2295 6.30018 16.1695 7.28018 11.9895L8.26018 7.79952C8.46018 6.94952 8.70018 6.20952 9.00018 5.59952C10.1702 3.17952 12.1602 2.52952 15.5002 3.31952L17.1702 3.70952C21.3602 4.68952 22.6402 6.75952 21.6602 10.9395Z",
    stroke: "#97A5A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0603 19.8896C14.4403 20.3096 13.6603 20.6596 12.7103 20.9696L11.1303 21.4896C7.16034 22.7696 5.07034 21.6996 3.78034 17.7296L2.50034 13.7796C1.22034 9.80961 2.28034 7.70961 6.25034 6.42961L7.83034 5.90961C8.24034 5.77961 8.63034 5.66961 9.00034 5.59961C8.70034 6.20961 8.46034 6.94961 8.26034 7.79961L7.28034 11.9896C6.30034 16.1696 7.59034 18.2296 11.7603 19.2196L13.4403 19.6196C14.0203 19.7596 14.5603 19.8496 15.0603 19.8896Z",
    stroke: "#97A5A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreNavIcon);
export default __webpack_public_path__ + "static/media/Explore_Nav_Icon.e4c99fc3da0fb4514f8952198240d24b.svg";
export { ForwardRef as ReactComponent };